import {cssTheme} from '../../theme'
import {css} from '../../theme/css'
import {breakpoints, spacing} from '../../theme/theme'

export const layoutClasses = {
  layout: css`
    flex: 1;
  `,
  layoutSidebar: css`
    display: flex;
  `,
  minor: css`
    background-color: ${cssTheme.default.day.backgroundMinor};
  `,
}
